// extracted by mini-css-extract-plugin
export default {"boxEntitySubTitle":"BoxSubTitle_boxEntitySubTitle__A7jK+","subTitleBold":"BoxSubTitle_subTitleBold__-wtI4"};